var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Mundo-del-Catalogo version: "),_c('span',{attrs:{"id":"version-local"}},[_vm._v(_vm._s(_vm.currentVersion))]),_c('span',{staticClass:"d-none",attrs:{"id":"version-remote"}},[_vm._v(_vm._s(_vm.newVersion))])])
}
var staticRenderFns = []

export { render, staticRenderFns }